import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE_URL } from "@/lib/api";

export default function Seo({
  title,
  description,
  path = "/",
  type = "website",
  jsonLd = [],
}) {
  const canonical = `https://compubrain.com/knowledge/${path}`;
  const blocks = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content="index, follow" />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="CompuBrain Knowledge Base" />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {blocks.filter(Boolean).map((b, i) => (
        <script type="application/ld+json" key={i}>
          {JSON.stringify(b)}
        </script>
      ))}
    </Helmet>
  );
}
